import React, { FormEvent } from 'react';
import styles from './authPageLayout.module.scss';
import logo from './logo.png';
import Button from '../button/Button';
import { NavLink } from 'react-router-dom';

type Common = {
  children: React.ReactNode | any;
  title: string;
  loading: boolean;
  buttonTitle: string;
  onSubmit: (e: FormEvent) => void;
  backToLogin?: boolean;
  isParentAuth?: boolean;
  isRegistration?: boolean;
  disableLogin?: boolean;
  isSuccessful?: boolean
}

type WithRender = {
  children: () => React.ReactNode;
}

type Props = Common | WithRender;

function AuthPageLayout(props: Props) {
  const { children } = props;
  const { title, loading, onSubmit, buttonTitle, backToLogin, isParentAuth, isRegistration, disableLogin, isSuccessful = false } = props as Common;

  return (
    <div className={styles.page}>
      <div className={styles.left}>
        <div className={styles.leftContent}>
          <div />
          <div className={styles.bodyContainer}>
            <img className={styles.logo} src={logo} alt="Logo"/>
            <div className={styles.textBody}>
              <h1 className={styles.title}>{isParentAuth ? '<Parent Tagline>' : isRegistration ? 'Plug & Play Mental Health Resources are just a few clicks away!' : 'Easy to deliver mental health classes are just a few clicks away!'}</h1>
              <h5 className={styles.description}>
                {
                  isParentAuth ? 'Teachers are not trained to be mental health experts. With pre-prepared Online Lessons created by Clinical Psychologists, your teachers can now support the mental health of all your students.'
                  : isRegistration ? 'Our team is available to assist you with any questions you have about running lessons, or how to get started using the program.' : 'Our Clinical Psychologists are available to answer any questions you have about delivering these lessons, and any mental health issues that arise in your classroom.'
                }
              </h5>
            </div>
          </div>
          <div />
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.rightContent}>
          <div className={styles.loginTitle}>{title}</div>
          {typeof children === 'function' ? children() :
            <form onSubmit={onSubmit}>
              {children}
              {!isSuccessful && <Button disabled={loading || disableLogin} className={isParentAuth ? styles.smallSubmit : styles.submit} type={'submit'} label={buttonTitle} isLoading={loading} />}
              {backToLogin &&
              <div className={styles.back}>
                Back&nbsp;to&nbsp;<NavLink className={styles.backLink} to={'/login'}>Login</NavLink>
              </div>
              }
            </form>
          }
        </div>
        <div className={styles.footer}>
          © {(new Date().getFullYear()) || '2022'} Open Parachute Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default AuthPageLayout;
